import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { toggleSidebar } from 'Redux/modules/ui/actions';

const useUI = () => {
  const dispatch = useDispatch();
  const ui = useSelector(state => state.ui, shallowEqual);

  const toggleSidebarUI = useCallback(() => {
    dispatch(toggleSidebar());
  }, [dispatch]);

  return {
    toggleSidebar: toggleSidebarUI,
    ui,
  };
};

export default useUI;
